<label class="{{styles.oy_checkbox_title}}"><span title="{{props.labelName}}" class="{{styles.item_content}}">{{props.labelName | maxLength props.maxTextLength}}:</span></label>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYRadioCheckbox/label.art